const Copyright = ({ data: { text, highlighText } }) => {
  return (
    <div className="copyright">
      <p>{text}<span>{highlighText}</span></p>
    </div>
  );
};

export default Copyright;
